import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { BazaKomenti } from '@core/interfaces/models/baza-komenti.interface';
import { Kerkimi } from '@core/interfaces/models/kerkimi.interface';
import { BazaKomentiService } from '@core/services/baza-komenti.service';
import { Subject, timer, switchMap, map, takeUntil } from 'rxjs';

@Component({
  selector: 'app-word-list-item',
  templateUrl: './word-list-item.component.html',
  styleUrls: ['./word-list-item.component.scss'],
})
export class WordListItemComponent implements OnInit {
  @Input() baza!: Kerkimi;
  @Input() index!: number;
  @Input() userId: string | null = null;

  @ViewChild('komentiDiv') komentiDiv!: ElementRef;

  komentetGroup?: { operatoriId?: string; komentet: BazaKomenti[] }[];

  private _komentiMouseLeave$: Subject<void> = new Subject<void>();

  constructor(private bazaKomentiService: BazaKomentiService) {}

  ngAfterViewInit(): void {}

  ngOnInit(): void {}

  mouseenter() {
    if (!this.komentetGroup || (this.komentetGroup.length > 0 && this.komentetGroup[0].komentet[0]?.bazaId != this.baza.id)) {
      timer(275)
        .pipe(
          switchMap(() => this.bazaKomentiService.get({ bazaId: this.baza.id, pageNumber: 1, pageSize: 6 })),
          map((komentet) => komentet.reverse()),
          map((komentet) => {
            let komentiGroup: { bazaId: number; operatoriId?: string; komentet: BazaKomenti[] }[] = [];
            komentet.forEach((k) => {
              if (komentiGroup.length > 0 && komentiGroup[komentiGroup.length - 1].operatoriId == k.regjistruarOperatoriId) {
                komentiGroup[komentiGroup.length - 1].komentet.push(k);
              } else {
                komentiGroup.push({ bazaId: this.baza.id, operatoriId: k.regjistruarOperatoriId, komentet: [k] });
              }
            });
            return komentiGroup;
          }),
          takeUntil(this._komentiMouseLeave$)
        )
        .subscribe((komentetGroup) => {
          this.komentetGroup = komentetGroup;
        });
    }
  }

  mouseleave() {
    this._komentiMouseLeave$.next();
  }

  // doesn't get called when scrolled out of virtual scroll
  ngOnDestroy(): void {}
}
